import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AiSearchDirective } from './search.directive';
import { MatFormFieldModule } from '@angular/material';

@NgModule({
  imports: [
    CommonModule,
    MatFormFieldModule
  ],
  declarations: [AiSearchDirective],
  exports: [AiSearchDirective, MatFormFieldModule]
})
export class AiInputModule {}
